import { render, staticRenderFns } from "./RepayModal.vue?vue&type=template&id=22ada2e3&"
import script from "./RepayModal.vue?vue&type=script&lang=js&"
export * from "./RepayModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports